import { Button, DatePicker, Modal } from 'antd';
import locale from 'antd/es/date-picker/locale/ko_KR';
import moment from 'moment';
import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { httpPost, httpUrl } from '../../api/httpClient';
import { categoryCode, pointType, modalErrorStyle } from '../../lib/util/codeUtil';
import { comma } from '../../lib/util/numberUtil';
import Pagination from '../input/Pagination';
import Const from "../../const";
import image from '../../res/image';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const now = new Date();
const PagedListSize = 5;

const header = [
  {
    orderIdx: '주문번호',
    createDate: '일시',
    category: '분류',
    pointType: '적립/차감',
    ncashDelta: '금액',
    afterNcash: '거래 후 잔액',
    riderName: '기사명',
    destAddr: '도착지',
  },
];

const DeliveryList = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 6,
    startDate: moment(now).add(-3, 'M').format(dateFormat),
    endDate: moment(now).format(dateFormat),
  });

  const [list, setList] = useState([]);
  const [currentList, setCurrentList] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectOpen, setSelectOpen] = useState(false);
  const [selectCategory, setSelectCategory] = useState(
    Object.keys(categoryCode)
  );

  useEffect(() => {
    getListAsync();
  }, [pagination, selectCategory]);

  const getListAsync = async () => {
    const pageNum = pagination.current;
    const pageSize = pagination.pageSize;
    const startDate = moment(pagination.startDate).format(dateFormat);
    const endDate = moment(pagination.endDate).add(1, 'day').format(dateFormat);

    try {
      const res = await httpPost(httpUrl.getDeliveryPriceSendLog, [], {
        // pageNum,
        // pageSize,
        startDate,
        endDate,
      });
      if (res.result !== 'SUCCESS') {
        setList([]);
        // setTotal(0);
        return;
      }

      if (res.data !== null) {
        setList(res.data.nyamnyamLog4DeliveryPriceSendList);
        setCurrentList(
          res.data.nyamnyamLog4DeliveryPriceSendList.slice(
            (pagination.current - 1) * pagination.pageSize,
            (pagination.current - 1) * pagination.pageSize + pagination.pageSize
          )
        );
        setTotal(res.data.nyamnyamLog4DeliveryPriceSendList.length);
      }
    } catch (e) {
      setList([]);
      setTotal(0);
      console.warn('getListAsync failed. ' + e);
    }
  };

  const onCheckList = (id) => {
    var selectedList = selectCategory;
    if (selectCategory.includes(id)) {
      setSelectCategory(selectedList.filter((x) => x !== id));
    } else {
      setSelectCategory([...selectedList, id]);
    }
  };

  const onChange = (page) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  const onChangeDatePickerStart = (_, dateString) => {
    var afterMonth = moment(dateString).add(+3, 'M').format(dateFormat);
    var beforeMonth = moment(dateString).add(-3, 'M').format(dateFormat);
    if (dateString) {
      if (new Date(pagination.endDate) - new Date(dateString) > 0) {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
        });
        if (new Date(pagination.endDate) - new Date(afterMonth) > 0) {
          alert('3달이내로 설정해주세요.');
          setPagination({
            ...pagination,
            current: 1,
            startDate: dateString,
            endDate: afterMonth,
          });
        }
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: pagination.endDate,
          endDate: dateString,
        });
        if (new Date(pagination.endDate) - new Date(beforeMonth) < 0) {
          alert('3달이내로 설정해주세요.');
          setPagination({
            ...pagination,
            current: 1,
            startDate: beforeMonth,
            endDate: dateString,
          });
        }
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M').format(dateFormat),
        endDate: moment(now).format(dateFormat),
      });
    }
  };

  const onChangeDatePickerEnd = (_, dateString) => {
    var beforeMonth = moment(dateString).add(-3, 'M').format(dateFormat);
    var afterMonth = moment(dateString).add(+3, 'M').format(dateFormat);
    if (dateString) {
      if (new Date(pagination.startDate) - new Date(dateString) < 0) {
        setPagination({
          ...pagination,
          current: 1,
          endDate: dateString,
        });
        if (new Date(pagination.startDate) - new Date(beforeMonth) < 0) {
          alert('3달이내로 설정해주세요.');
          setPagination({
            ...pagination,
            current: 1,
            startDate: beforeMonth,
            endDate: dateString,
          });
        }
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
          endDate: pagination.startDate,
        });
        if (new Date(pagination.startDate) - new Date(afterMonth) > 0) {
          alert('3달이내로 설정해주세요.');
          setPagination({
            ...pagination,
            current: 1,
            startDate: dateString,
            endDate: afterMonth,
          });
        }
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M').format(dateFormat),
        endDate: moment(now).format(dateFormat),
      });
    }
  };

  const onChangeRangePicker = (_, dateString) => {
    // const startDate = dateString[0];
    // const endDate = dateString[1];
    var afterDateStringStart = dateString[0].split('-');
    var afterDateStringEnd = dateString[1].split('-');
    if (dateString[0]) {
      setPagination({
        ...pagination,
        current: 1,
        startDate: dateString[0],
        endDate: dateString[1],
      });
      if (
        parseInt(afterDateStringEnd[1]) - parseInt(afterDateStringStart[1]) >
        3
      ) {
        alert('3달이내로 설정해주세요.');
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString[0],
          endDate: moment(dateString[0]).add(+3, 'M'),
        });
      } else {
        return;
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M'),
        endDate: now,
      });
    }
  };

  const onDownload = async () => {
    const startDate = moment(pagination.startDate).format(dateFormat);
    const endDate = moment(pagination.endDate).add(1, 'day').format(dateFormat);

    const res = await httpPost(httpUrl.getDeliveryPriceSendLog, [], {
      startDate,
      endDate,
    });
    if (res.result !== 'SUCCESS') {
      Modal.error({
        title: '엑셀 다운로드 오류',
        content: (
          <div>
            엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
          </div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    const title = '통계';
    const filename = moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';

    const jsonData = res.data.nyamnyamLog4DeliveryPriceSendList.map((row) => ({
      orderIdx: row.orderIdx,
      createDate: moment(row.createDate).format('YYYY-MM-DD HH:mm'),
      category: categoryCode[row.category],
      pointType:
        row.ncashDelta == null
          ? pointType[0]
          : row.ncashDelta > 0
          ? pointType[1]
          : row.ncashDelta < 0
          ? pointType[2]
          : '',
      ncashDelta: row.ncashDelta,
      afterNcash: row.afterNcash,
      riderName: row.riderName,
      destAddr: row.destAddr1 + ' ' + row.destAddr2,
    }));

    const array = header.concat(jsonData);

    var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
    var wb = XLSX.utils.book_new();

    ws['!cols'] = [];
    ws['!cols'][1] = { width: 20 };
    ws['!cols'][2] = { width: 15 };
    ws['!cols'][7] = { width: 100 };

    XLSX.utils.book_append_sheet(wb, ws, '전체내역');
    XLSX.writeFile(wb, filename);
  };

  const skinType = Const.skinType.toUpperCase();

  return (
    <div className="calculate-adjustment-element">
      <div className="calculate-element-sub">
        <div className="calculate-element-sub-content">
          <div
            className="calculate-adjustment-element-menu-btn mobileoff"
            onClick={() => {}}>
            <Button className="excel" onClick={() => onDownload()}>
              엑셀 다운로드 &nbsp;
              <img
                style={{ display: 'inline' }}
                src={image.DownloadIcon}
                className="download-img"
                alt=""
              />
            </Button>
          </div>
          <div className="calculate-content-date cal-date-sub2">
            <DatePicker
              className="desk"
              placeholder={'시작일'}
              locale={locale}
              style={{
                height: '50px',
                borderRadius: '10px',
                marginTop: '-5px',
              }}
              size="large"
              format={dateFormat}
              value={moment(pagination.startDate, dateFormat)}
              onChange={onChangeDatePickerStart}
              inputReadOnly
              showToday={false}
            />
            <DatePicker
              className="desk"
              placeholder={'종료일'}
              locale={locale}
              style={{
                height: '50px',
                borderRadius: '10px',
                marginTop: '-5px',
              }}
              size="large"
              format={dateFormat}
              value={moment(pagination.endDate, dateFormat)}
              onChange={onChangeDatePickerEnd}
              inputReadOnly
              showToday={false}
            />
            <DatePicker
              className="pos"
              placeholder={'시작일'}
              locale={locale}
              style={{
                height: '40px',
                borderRadius: '10px',
                marginTop: '-5px',
              }}
              size="middle"
              format={dateFormat}
              value={moment(pagination.startDate, dateFormat)}
              onChange={onChangeDatePickerStart}
              inputReadOnly
              showToday={false}
            />
            <DatePicker
              className="pos"
              placeholder={'종료일'}
              locale={locale}
              style={{
                height: '40px',
                borderRadius: '10px',
                marginTop: '-5px',
              }}
              size="middle"
              format={dateFormat}
              value={moment(pagination.endDate, dateFormat)}
              onChange={onChangeDatePickerEnd}
              inputReadOnly
              showToday={false}
            />
            {/* <RangePicker
            className="desk"
            placeholder={["시작일", "종료일"]}
            locale={locale}
            style={{ height: "50px", borderRadius: "10px", marginTop: "-5px" }}
            size="large"
            format={dateFormat}
            value={[
              moment(pagination.startDate, dateFormat),
              moment(pagination.endDate, dateFormat),
            ]}
            onChange={onChangeRangePicker}
          /> */}
            {/* <RangePicker
            className="pos"
            placeholder={["시작일", "종료일"]}
            locale={locale}
            style={{ height: "40px", borderRadius: "10px", marginTop: "-5px" }}
            size="middle"
            format={dateFormat}
            value={[
              moment(pagination.startDate, dateFormat),
              moment(pagination.endDate, dateFormat),
            ]}
            onChange={onChangeRangePicker}
          /> */}
          </div>
        </div>
        <div className="allList-element-all">
          <div className="allList-element-block">
            <div className="allList-element-block-menu">
              <div className="deliveryList-element-block-menu-text mobileoff">
                주문번호
              </div>
              <div className="deliveryList-element-block-menu-text deliveryList-all2">
                일시
              </div>
              {/* <div className="allList-element-block-menu-text all3">분류</div> */}
              {/* <div className="allList-element-block-menu-text all4 mobileoff">
              적립/차감
            </div> */}
              <div className="deliveryList-element-block-menu-text deliveryList-all5">
                금액
              </div>
              <div className="deliveryList-element-block-menu-text deliveryList-all6">
                잔액
              </div>
              <div className="deliveryList-element-block-menu-text deliveryList-all7">
                기사명
              </div>
              <div className="deliveryList-element-block-menu-text deliveryList-all8">
                도착지
              </div>
              {/* <div className="deliveryList-element-block-menu-text deliveryList-all9">비고</div> */}
            </div>
          </div>

          {(!list || list.length) === 0 && (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              내역이 없습니다.
            </div>
          )}
          {currentList &&
            currentList.map((row, index) => (
              <div
                key={index}
                className={
                  'deliveryList-element-block-field' +
                  (index % 2 === 0 ? '' : ' odd')
                }>
                <div className="deliveryList-element-block-field-text deliveryList-all-sub3 mobileoff">
                  {row.orderIdx}
                </div>
                <div className={"deliveryList-element-block-field-text" + (skinType === "GOGOIT" ? " gogoit-deliveryList-all-sub1" : " deliveryList-all-sub1")}>
                  <div>{moment(row.orderDate).format('YYYY-MM-DD HH:mm')}</div>
                </div>
                {/* <div className="allList-element-block-field-text all-sub2">
                {categoryCode[row.category]}
              </div> */}
                {/* <div className="allList-element-block-field-text all-sub4 mobileoff">
                {row.ncashDelta == null
                  ? pointType[0]
                  : row.ncashDelta > 0
                  ? pointType[1]
                  : row.ncashDelta < 0
                  ? pointType[2]
                  : ""}
              </div> */}
                <div className="deliveryList-element-block-field-text deliveryList-all-sub5">
                  {comma(row.ncashDelta)}
                </div>
                <div className="deliveryList-element-block-field-text deliveryList-all-sub6">
                  {comma(row.afterNcash)}
                </div>
                <div className="deliveryList-element-block-field-text deliveryList-all-sub7">
                  {row.riderName}
                </div>
                <div className="deliveryList-element-block-field-text deliveryList-all-sub8">
                  {row.destAddr1 + ' ' + row.destAddr2}
                </div>
                {/* <div className="deliveryList-element-block-field-text deliveryList-all-sub9">
                {row.riderName +
                  "에게 배달비 " +
                  comma(-row.ncashDelta) +
                  "원 송금"}
              </div> */}
              </div>
            ))}
        </div>

        <div className="allList-element-btn mobileoff">
          <Pagination
            current={pagination.current}
            total={total}
            pageSize={pagination.pageSize}
            pagedListSize={PagedListSize}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};

export default DeliveryList;
